import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { TimesheetDetails } from '@/components/timesheets/timesheets-view-more'
import { Button } from '@/components/ui/button'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { DateTime } from 'luxon'

export const Route = createFileRoute('/dashboard/admin/timesheets/$timesheetId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { timesheetId } = Route.useParams()
  const api = useTRPC()
  const { data: bracketHolidays } = useQuery({
    ...api.bracketHolidays.getAllBracketsAndHolidays.queryOptions({
      fromDate: DateTime.now().minus({ years: 1 }).startOf('year').toFormat('yyyy-MM-dd'),
      toDate: DateTime.now().endOf('year').toFormat('yyyy-MM-dd'),
    }),
  })

  return (
    <DashboardShell>
      <div className="flex items-center justify-between">
        <DashboardHeader heading="Timesheet" text={undefined} />
        <Link to="/dashboard/admin/timesheets">
          <Button variant="outline" size="sm">
            Back
          </Button>
        </Link>
      </div>
      <div className="bg-background rounded-lg border">
        <TimesheetDetails
          context="page"
          timesheetId={timesheetId}
          bracketHolidays={bracketHolidays}
        />
      </div>
    </DashboardShell>
  )
}
